<template>
	<div class="partial-container partial-notification minified-sidebar" :class="{ 'auth-page': isAuthPage }">
		<div v-for="(notification, index) in notifications" :key="index" class="notification-item" :class="[`n-type--${notification.type}`]">
			<div class="icon">
				<i v-if="notification.type === 'success'" class="fa-icon fas fa-check" />
				<i v-if="notification.type === 'notice'" class="fa-icon fas fa-info" />
				<i v-if="notification.type === 'warning'" class="fa-icon fas fa-exclamation" />
				<i v-if="notification.type === 'error'" class="fa-icon fas fa-times" />
			</div>
			<div class="message">
				<p class="text" v-text="notification.message" />
				<p v-if="notification.repeated > 0" class="text repeated" v-text="`x${notification.repeated}`" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useRoute } from 'vue-router';
	import { useStore } from 'vuex';
	import { computed } from 'vue';

	const route = useRoute();
	const store = useStore();
	const notifications = computed(() => store.state.notification.notifications);

	const isAuthPage = computed(() => {
		if (route.path.includes('/auth/')) return true;
		return false;
	});
</script>

<style lang="scss" scoped>
	@use '../assets/styles/partials/notification';

	.message p {
		white-space: break-spaces;
	}
</style>
